import React from 'react';
import { PickingProgressResponse } from '@ydistri/api-sdk';
import { Row } from '@ydistri/ds';
import SourceStoresPickingProgressInfo from './SourceStoresPickingProgressInfo';
import RoutesPickingProgressInfo from './RoutesPickingProgressInfo';

interface PickingProgressInfoProps {
  pickingProgress: PickingProgressResponse;
  showInProgressRoutes?: boolean;
}

/**
 * Displays the number of source stores and routes that are in progress, finished, or not started.
 * Also shows the total number of source stores and routes.
 */
const PickingProgressInfo: React.FC<PickingProgressInfoProps> = ({
  pickingProgress,
  showInProgressRoutes = false,
}) => {
  const { routes, sourceStores, rate } = pickingProgress;

  return (
    <Row $gap="3rem">
      <SourceStoresPickingProgressInfo sourceStoresPickingProgress={sourceStores} />
      <RoutesPickingProgressInfo
        routesPickingProgress={routes}
        pickingProgressRate={rate}
        showInProgress={showInProgressRoutes}
      />
    </Row>
  );
};

export default PickingProgressInfo;
